<template>
  <div>
    <input
      id="subcategoria-id"
      type="hidden"
      v-model="subcategoria.id"
    />
    <input
      id="subcategoria-uuid"
      type="hidden"
      v-model="subcategoria.uuid"
    />
    <input
      id="subcategoria-user"
      type="hidden"
      v-model="subcategoria.usuario"
    />
    <v-row>
      <v-col
        cols="12"
        md="8"
      >
        <v-text-field
          v-model="subcategoria.subcategoria"
          label="Subcategoria"
          outlined
          required
          dense
          v-if="mode === 'save'"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="8"
      >
        <v-textarea
          v-model="subcategoria.ds_subcategoria"
          label="Descrição"
          auto-grow
          outlined
          rows="3"
          row-height="25"
          dense
          v-if="mode === 'save'"
        >
        </v-textarea>
      </v-col>
    </v-row>
  </div>
</template>
<script>
export default {
  name: 'SubCategoria',
  props: {
    subcategoria: {}, mode: { type: String, default: 'save' }
  }
}
</script>
